import Card from "../../../componentes/contenedores/Card";
import Page from "../../../componentes/plantilla/Page";
import HistorialTemperatura from "./Historiales/HistorialTemperatura";
import HistorialHumedadRelativa from "./Historiales/HistorialHumedadRelativa";
import HistorialSuelo from "./Historiales/HistorialSuelo";
import HistorialIluminacion from "./Historiales/HistorialIluminacion";

const InicioEmpleados = () => {
  const datos = {
    titulo: {
      titulo: "Página principal",
      url: "/app/admin/invernaderos/",
      tituloUrl: "Menú Principal",
      nombreUrl: "Inicio",
    },
  };

  return (
    <Page datos={datos}>
      <Card titulo="Datos de sensores en tiempo real">
        <div className="row">
          <div className="col-12">
            <HistorialTemperatura />
          </div>
          <div className="col-12">
            <HistorialHumedadRelativa />
          </div>
          <div className="col-12">
            <HistorialSuelo />
          </div>
          <div className="col-12">
            <HistorialIluminacion />
          </div>
        </div>
      </Card>
    </Page>
  );
};

export default InicioEmpleados;